var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuMain = function SvgMenuMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menu-main_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.819 5.163c2.889-2.1 4.333-3.149 5.983-3.21q.199-.006.397 0c1.65.061 3.094 1.11 5.984 3.21 2.889 2.099 4.333 3.148 4.9 4.698q.069.187.123.378c.452 1.588-.1 3.286-1.203 6.682L21.14 22.66a2.213 2.213 0 0 1-4.318-.684v-2.978c0-1.147-.93-2.077-2.076-2.077h-3.489c-1.146 0-2.076.93-2.076 2.077v2.978a2.213 2.213 0 0 1-4.317.684L2.998 16.92c-1.103-3.396-1.655-5.094-1.203-6.682q.054-.19.123-.378c.567-1.55 2.012-2.6 4.9-4.698"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menu-main_svg__a",
    width: 70.728,
    height: 70.239,
    x: -22.363,
    y: -22.05,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_56_4330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_56_4330",
    result: "shape"
  })))));
};
export { SvgMenuMain as ReactComponent };